<div class="notification-container" *ngIf="(toast.showsToast$ | async)" [@fadeInOut]="'in'">
  <div class="notification" [class]="toast.toastState$ | async">
    <button class="delete" (click)="close()"></button>
    {{ toast.toastMessage$ | async }}
  </div>
</div>
